/* eslint-disable @typescript-eslint/no-var-requires */
import { StoreEnhancer } from 'redux'

let reactotron:
  | {
      createEnhancer: () => StoreEnhancer
    }
  | undefined

if (process.env.NODE_ENV === 'development') {
  const Reactotron = require('reactotron-react-js').default
  const { reactotronRedux } = require('reactotron-redux')

  reactotron = Reactotron.configure().use(reactotronRedux()).connect()
}

export default reactotron
